import { KeyboardEvent, useRef, useState } from "react";
import {
  Popper,
  MenuList,
  ClickAwayListener,
  Paper,
  PopperProps,
} from "@mui/material";
import { theme } from "$utils/theme/bataillog";

type Props = {
  BtnLabel?: any;
  BtnClickAction?: () => void;
  BtnIcon?: any;
  BtnIconRight?: any;
  BtnComponent?: any;
  BtnProps?: any;
  children?: any;
  className?: string;
  disabled?: boolean;
  popperProps?: Partial<PopperProps>;
};

function BtnPoper({
  BtnLabel,
  BtnClickAction,
  BtnIcon,
  BtnIconRight,
  BtnComponent,
  BtnProps,
  children,
  className,
  disabled,
  popperProps,
}: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    if (BtnClickAction) {
      BtnClickAction();
    }
  };

  const handleClose = (event: Event) => {
    // Updated event handling for MUI 5
    if (anchorRef.current && anchorRef.current.contains(event.target as Node)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event: KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  return (
    <div ref={anchorRef} className={className} style={{ zIndex: 3 }}>
      <BtnComponent
        disabled={disabled}
        onClick={handleToggle}
        {...(BtnProps || {})}
        style={{ marginRight: 0 }}
      >
        {BtnIcon && <BtnIcon />}
        {BtnLabel && BtnLabel}
        {BtnIconRight && <BtnIconRight />}
      </BtnComponent>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-end"
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 2],
            },
          },
        ]}
        sx={{
          zIndex: 1300,
          marginTop: "2px",
        }}
        {...popperProps}
      >
        <Paper
          elevation={8}
          style={{
            backgroundColor: theme.color?.white || "#FFFFFF",
            color: theme.color?.black || "#2D2D2D",
            borderRadius: "4px",
          }}
        >
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList
              autoFocusItem={open}
              id="menu-list-grow"
              onKeyDown={handleListKeyDown}
              style={{ padding: 0 }}
            >
              {children && children}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popper>
    </div>
  );
}

export default BtnPoper;
